function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "image-mask",
  clipPathUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.001,0.166 C0,0.16,0.003,0.155,0.007,0.155 L0.994,0.001 C0.998,0.001,1,0.006,1,0.012 L0.91,0.993 C0.91,0.998,0.907,1,0.903,1 L0.072,0.878 C0.069,0.878,0.066,0.875,0.066,0.87 L0.001,0.166"
}));

var SvgImageMask = function SvgImageMask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageMask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-mask.35cdbe4e.svg";
export { ForwardRef as ReactComponent };